import React from 'react';
import PropTypes from 'prop-types';
import FormField from '@adsk/alloy-react-form-field';
import TextInput from '@adsk/alloy-react-text-input';
import { LinkButton } from '@adsk/alloy-react-button';
import { OpenIcon } from '@adsk/alloy-react-icon';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import Theme from '@adsk/alloy-react-theme';
import { useLocale } from '@adsk/alloy-react-locale';
import FieldWrapper from '../FieldWrapper';

const ProjectTemplateField = ({
  isEditing,
  isTemplateMember,
  placeHolder,
  title,
  value,
  isArchived,
  url,
}) => {
  const { T } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );

  const openProjectInNewTab = (urlTemplate) => {
    window.open(urlTemplate, '_blank', 'noopener,noreferrer');
  };

  const disabledUpdate = true;
  const content = isEditing ? (
    <FormField>
      <TextInput
        type="text"
        placeholder={disabledUpdate ? value : placeHolder}
        value={value ?? ''}
        disabled={disabledUpdate}
      />
    </FormField>
  ) : (
    <>
      {value ? (
        isArchived ? (
          <div className="flex flex-row">
            <OverflowTooltip>
              <span>{value}</span>
              <span
                style={{ color: Theme.colors.charcoal600, paddingLeft: '7px' }}
              >
                ({T.translate('PROJECT_TEMPLATE_ARCHIVED')})
              </span>
            </OverflowTooltip>
          </div>
        ) : isTemplateMember && url ? (
          <LinkButton
            onClick={() => {
              openProjectInNewTab(url);
            }}
            className="flex height-all"
            style={{
              color: Theme.colors.adskBlue700,
              justifyContent: 'left',
              maxWidth: '90%',
            }}
          >
            <OverflowTooltip>{value}</OverflowTooltip>
            <OpenIcon
              className="openIcon"
              style={{ paddingLeft: '7px', display: 'block' }}
            />
          </LinkButton>
        ) : (
          <OverflowTooltip>{value}</OverflowTooltip>
        )
      ) : (
        T.translate('PROJECT_NOT_AVAILABLE')
      )}
    </>
  );

  return (
    <FieldWrapper isEditing={isEditing} title={title}>
      {content}
    </FieldWrapper>
  );
};

ProjectTemplateField.propTypes = {
  isArchived: PropTypes.bool,
  isEditing: PropTypes.bool.isRequired,
  isTemplateMember: PropTypes.bool,
  placeHolder: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  value: PropTypes.string,
};

ProjectTemplateField.defaultProps = {
  isArchived: false,
  isTemplateMember: false,
  url: undefined,
  value: undefined,
};

export default ProjectTemplateField;
